/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Seated/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconChair from 'DesignSystem/Svgs/TysiaIconChair/index'



/** @type {import('Simple/types.js').View} */
export default function Seated({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Indicator/Past/Icon/Seated"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaIconChair
  viewPath={`${viewPath}/TysiaIconChair`}
 fill={dtColorsWhite}
 width={16}
 height={16}
/>
{children}
</React.Fragment>)
}